import Vue from 'vue';

Vue.config.errorHandler = (err, vm, info) => {
  console.log(err, vm, info);
};

window.onerror = (message, source, lineno, colno, error) => {
  console.log(message, source, lineno, colno, error);
};
